// imports section Start
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  externalgetApi,
  externalpostApi,
} from "../../../services/external/externalApis";
import { ORDER_API_07 } from "../../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
  CON_TAX_PAGE_CODE,
  CON_ADDON_CODE,
  CON_IS_ADDON,
  CON_CODENRATE,
  CON_TAX_CODE,
  CON_TAX_RATE,
  CON_TAX_AMOUNT,
  CON_IS_CASHIER_YES,
  CON_DELIVERY_STS,
  CON_GUEST_REF_CODE,
  CON_IP_ADDRESS,
  CON_STATUS_PENDING,
  CON_EMPTY_VALUE,
  CON_VALUE_ZERO,
  CON_IS_CREDIT_NO,
  CON_VALUE_ZERO_ST,
  CON_IS_CASHIER_NO,
  CON_IS_ADDON_YES,
} from "../../../utils/sys/Constants";
import useClientIP from "../../../utils/common/ClientIP";
import SnackbarMessage from "../../../components/common/SnackbarMessage";
import {
  MSG_CASHIER_FAILED,
  MSG_CASHIER_SUCCESS,
  MSG_EMPTY_CART,
} from "../../../utils/sys/Messages";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import MenuIcon from "@mui/icons-material/Menu";
import { useStyles } from "../../../assets/styles/Theme";
import CashierDelivery from "../../../components/cashier/cashier/CashierDelivery";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import RedeemIcon from "@mui/icons-material/Redeem";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CashierVoucher from "./CashierVoucher";
import CashierCheque from "./CashierCheque";
import CashierCard from "../cashier/CashierCard";
import CashierCash from "../cashier/CashierCash";
import CashierSlip from "./CashierSlip";
import { CashierContext } from "../../../features/cashier/Cashier";
import {
  Box,
  Grid,
  Typography,
  Tab,
  Tabs,
  IconButton,
  Button,
} from "@mui/material";
import CashierLoyalty from "./CashierLoyalty";
import { setVoucherData } from "../../../store/ReduxVoucherSlice";
import { clearCashierCart } from "../../../store/ReduxCashierCartReducer";
import { resetCards } from "../../../store/ReduxCardSlice";
import {
  setRedeemAmount,
  clearLoyaltyData,
} from "../../../store/ReduxLoyaltySlice";
// imports section End

function CashierTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CashierTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const CashierPayment = ({}) => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientIP = useClientIP();
  const location = useLocation();
  const [depositTabValue, setDepositTabValue] = React.useState(0);
  const [redeemTabValue, setRedeemTabValue] = React.useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Control Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [value, setValue] = useState(0); // Main tab
  const [nestedValue, setNestedValue] = useState(0); // Payment method tabs
  const cartItems = useSelector((state) => state.cashierCart.items);
  const { ordercode } = location.state || {};

  // Assuming cardList is retrieved from sessionStorage or localStorage
  const cardList = useSelector((state) => state.cards.cardList);
  const chequeList = useSelector((state) => state.cheques.chequeList);
  const slipList = useSelector((state) => state.slips.slipList);
  const voucherList = useSelector((state) => state.vouchers.voucherList);
  const redeemAmountFromRedux = useSelector(
    (state) => state.loyalty.redeemAmount
  );

  // Extract loyaltyData from Redux store
  const loyaltyData = useSelector((state) => state.loyalty.loyaltyData);

  // Safely retrieve GUESTREFCODE from Table2
  const guestRefCode =
    loyaltyData?.Table2?.[0]?.GUESTREFCODE || CON_GUEST_REF_CODE;

  const {
    selectedOrderType,
    selectedWaiterTables,
    selectedWaiters,
    cashTendered,
    advanceAmount,
    shippingCharge,
    adjustment,
    discountedTotal,
    table1Data,
    table2Data,
    table3Data,
    grossAmount,
    calculateItemTotal,
    deliveryDate,
    deliveryTime,
    contactPerson,
    contactNumber,
    deliveryAddress,
    setCashTendered,
    setAdvanceAmount,
    setDiscountedTotal,
    setShippingCharge,
    setAdjustment,
    setDiscountValue,
    responseValues,
    setResponseValues,
    formData,
    setFormData,
    totalAmountBank,
    cardTotalAmount,
    slipTotalAmount,
    chequeTotalAmount,
    totalAmountRedeem,
    voucherTotalAmount,
    orderDetails,
    setOrderDetails,
    orderBillDetails,
    setOrderBillDetails,
    officerName,
    setOfficerName,
    selectedRooms,
    setSelectedRooms,
  } = useContext(CashierContext);

  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, CATTYPE, USERNAME } =
    SYS_USER.USER_PARAM || {};

  // Handlers start
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  // Function to update voucher details in formData
  const setVoucherData = (voucherDetails) => {
    setFormData((prevData) => ({
      ...prevData,
      redeem: {
        ...prevData.redeem,
        voucher: voucherDetails,
      },
    }));
  };

  const handleDepositTabChange = (event, newValue) => {
    setDepositTabValue(newValue);
  };

  const handleRedeemTabChange = (event, newValue) => {
    setRedeemTabValue(newValue);
  };

  // Handle main tab change
  const handleChange = (event, newValue) => setValue(newValue);

  // Handle nested payment tab change
  const handleNestedChange = (event, newValue) => setNestedValue(newValue);

  // Update formData for each payment type dynamically
  const handleFormDataChange = (type, subType, data) => {
    setFormData((prev) => ({
      ...prev,
      [type]: subType ? { ...prev[type], [subType]: data } : data,
    }));
  };

  const formattedDeliveryTime = deliveryTime
    ? deliveryTime.format("HH:mm:ss")
    : "";

  const ValidatePayConfirmation = () => {
    try {
      var isValid = true;
      if (parseFloat(responseValues.balance).toFixed(4) < 0) {
        isValid = false;
      }
      return isValid;
    } catch {
      setSnackbarMessage("Error processing payment.");
      setSnackbarOpen(true);
      return false;
    }
  };
  // Handlers end

  // API calls start

  // Confirm order with dynamic payload including multiple payment types
  const handleConfirmOrder = async () => {
    if (!ValidatePayConfirmation()) {
      setSnackbarMessage("Payment Failed. Insufficient funds to pay the bill.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    const dtPay = [];
    const dtVoucher = [];
    // const dtVoucher = [];

    // const combinedItems = [
    //   ...(Array.isArray(orderDetails.items) ? orderDetails.items : []),
    //   ...(Array.isArray(cartItems) ? cartItems : []),
    // ];

    // Combine items from orderDetails and cartItems
    const activeOrderDetailsItems = (orderDetails.items || []).map((item) => ({
      ...item,
      sts: CON_STATUS_ACTIVE,
    }));

    const pendingCartItems = (cartItems || []).map((item) => ({
      ...item,
      sts: CON_STATUS_PENDING,
    }));

    const combinedItems = [...activeOrderDetailsItems, ...pendingCartItems];
    if (!combinedItems || combinedItems.length === 0) {
      setSnackbarMessage(MSG_EMPTY_CART);
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return; // Exit early
    }

    const dtDetail = combinedItems.flatMap((item, index) => {
      // Main item
      const mainItem = {
        kotseqcode: index + 1,
        addoncode: CON_ADDON_CODE, // Default addon code for main item
        menucatcode: String(item.MENUCATCODE),
        menucode: String(item.MENUCODE),
        qty: item.quantity || item.QTY || 1,
        rate: parseFloat(item.ITEMRATE || item.RATE || 0),
        amount: parseFloat(calculateItemTotal(item).toFixed(2)),
        remark: String(item.REMARK || ""),
        isaddon: CON_IS_ADDON, // Main item flag
        sts: item.sts,
      };

      // Addon items
      const addonItems = (item.addons || []).map((addon) => ({
        kotseqcode: index + 1, // Same sequence as the parent item
        addoncode: String(addon.ADDONCODE), // Unique addon code
        menucatcode: String(item.MENUCATCODE), // Parent's category code
        menucode: String(item.MENUCODE), // Parent's menu code
        qty: item.quantity || item.QTY || 1, // Match parent item quantity
        rate: parseFloat(addon.RATE || 0),
        amount: parseFloat((addon.RATE * (item.quantity || 1)).toFixed(2)), // Total for addon
        remark: addon.DESCRIP || "", // Addon's description
        isaddon: CON_IS_ADDON_YES, // Addon flag
        sts: item.sts, // Addon status
      }));

      // Combine main item and its addons
      return [mainItem, ...addonItems];
    });

    if (formData.cash?.amount) {
      dtPay.push({
        paymode: "CA", // Paymode for Cash
        clientname: formData.cash.clientname || "",
        refno: formData.cash.refno || "",
        bank: "",
        branch: "",
        amount: formData.cash.amount,
      });
    }

    // Handle Card Payment
    // Process card payments from Redux
    cardList.forEach((card) => {
      if (card.cardamount) {
        dtPay.push({
          paymode: "VS",
          clientname: card.cardname || "",
          refno: card.cardaccountNumber || "",
          bank: card.cardbank || "",
          branch: card.cardbranch || "",
          amount: card.cardamount || 0,
        });
      }
    });

    // Process sliplist payments from Redux
    slipList.forEach((slip) => {
      if (slip?.slipamount) {
        dtPay.push({
          paymode: "OS",
          clientname: slip.slipname || "",
          refno: "0",
          bank: slip.slipbank || "",
          branch: slip.slipbranch || "",
          amount: slip.slipamount || 0,
        });
      }
    });

    // Process chequeList payments from Redux
    chequeList.forEach((cheque) => {
      if (cheque?.chequeamount) {
        dtPay.push({
          paymode: "CP",
          clientname: cheque.chequename || "",
          refno: "0",
          bank: cheque.chequebank || "",
          branch: cheque.chequebranch || "",
          amount: cheque.chequeamount || 0,
        });
      }
    });

    // Ensure at least one empty payment object is included if no payments are added
    const dtPayParam =
      dtPay.length > 0
        ? dtPay
        : [
            {
              paymode: "0",
              clientname: "0",
              refno: "0",
              bank: "0",
              branch: "0",
              amount: 0,
            },
          ];

    // Handle Redeem (Loyalty and Voucher)
    // if (
    //   formData.redeem?.loyalty?.chequeamount !== null &&
    //   formData.redeem?.loyalty?.chequeamount !== undefined
    // ) {
    if (formData.redeem?.loyalty?.amount) {
      dtPay.push({
        paymode: "LOYALTY",
        clientname: formData.redeem.loyalty.clientname || "",
        refno: "",
        bank: "",
        branch: "",
        amount: formData.redeem.loyalty.amount,
      });
    }

    // Process chequeList payments from Redux
    voucherList.forEach((voucher) => {
      if (voucher?.voucheramount) {
        dtVoucher.push({
          refcode: String(voucher.voucherrefcode) || "",
          vouchercode: String(voucher.vouchercode) || "",
          voucherno: voucher.voucherno || "",
          barcode: voucher.voucherbarcode || "",

          amount: voucher.voucheramount || 0,
        });
      }
    });

    const dtVoucherParam =
      dtVoucher.length > 0
        ? dtVoucher
        : [
            {
              refcode: "0",
              vouchercode: "0",
              voucherno: "0",
              barcode: "0",
              amount: 0,
            },
          ];

    // Map over table2 to create dtTax entries
    const dtTax =
      Array.isArray(table2Data) && table2Data.length > 0
        ? table2Data.map((taxItem) => ({
            taxpgcode: taxItem.TAXPAGECODE ? String(taxItem.TAXPAGECODE) : "0", // default to "0" if empty
            compcode: taxItem.COMPCODE ? String(taxItem.COMPCODE) : "0", // default to "0" if empty
            loccode: taxItem.LOCCODE ? String(taxItem.LOCCODE) : "0", // default to "0.00" if empty
            taxcode: taxItem.TAXCODE ? String(taxItem.TAXCODE) : "0",
            taxrate: taxItem.TAXRATE || 0,
            amount: taxItem.TAXAMOUNT || 0, // default to "0.00" if empty
          }))
        : [
            // If no data exists, send a single item with default empty values
            {
              taxpgcode: "0", // default empty value
              compcode: "0", // default empty value
              loccode: "0", // default empty value
              taxcode: "0",
              taxrate: 0,
              amount: 0,
            },
          ];

    // Map over table3Data to create dtTax entries
    const dtCharges =
      Array.isArray(table3Data) && table3Data.length > 0
        ? table3Data.map((chargeItem) => ({
            ordertypecode: chargeItem.ORDERTYPECODE
              ? String(chargeItem.ORDERTYPECODE)
              : "0", // default to "0" if empty
            chargecode: chargeItem.CHARGECODE
              ? String(chargeItem.CHARGECODE)
              : "0", // default to "0" if empty
            chargerate: chargeItem.CHARGERATE || 0, // default to "0.00" if empty
            amount: chargeItem.CHARGEAMOUNT || 0, // default to "0.00" if empty
          }))
        : [
            // If no data exists, send a single item with default empty values
            {
              ordertypecode: "0", // default empty value
              chargecode: "0", // default empty value
              chargerate: 0, // default empty value
              amount: 0, // default empty value
            },
          ];
    const isPlaceOrder = orderDetails?.items?.length > 0;
    const payload = {
      dtDetail,
      dtTax,
      dtCharges,
      dtPay: dtPayParam,
      dtVoucher: dtVoucherParam,
      compcode: COMPCODE,
      loccode: LOCCODE,
      restcode: RESTCODE,
      ordercode: ordercode ? String(ordercode) : CON_EMPTY_VALUE, // Provide the order code if available
      guestordercode: CON_EMPTY_VALUE, // Optional guest order code
      terminalcode: clientIP, // Set the terminal code if required
      paymentcode: CON_EMPTY_VALUE, // Provide if necessary
      guestrefcode: String(guestRefCode) || CON_GUEST_REF_CODE,
      tablecode: selectedWaiterTables ? selectedWaiterTables.toString() : "",
      orderendate: new Date().toISOString().split("T")[0],
      deliverydate: String(deliveryDate),
      deliverytime: formattedDeliveryTime,
      billamount: table1Data.TOTNETT || CON_VALUE_ZERO,
      discount: table1Data.DISCOUNT || CON_VALUE_ZERO,
      paidamount: table1Data.TOTPAID || CON_VALUE_ZERO,
      advanceamount: advanceAmount || 0,
      shippingamount: shippingCharge || 0,
      balanceamount: String(responseValues.balance) || CON_VALUE_ZERO_ST,
      remark: CON_EMPTY_VALUE,
      ordersts: CON_STATUS_ACTIVE,
      orderdetsts: CON_STATUS_ACTIVE,
      paymentsts: CON_STATUS_ACTIVE,
      deliverysts: CON_DELIVERY_STS,
      officername: String(officerName),
      enuser: String(USERNAME),
      locdate: new Date().toISOString().split("T")[0],
      roomnocode: selectedRooms ? selectedRooms.toString() : "",
      ordertype: selectedOrderType ? selectedOrderType.toString() : "",
      iscashier: CON_IS_CASHIER_YES,
      paymode: CON_EMPTY_VALUE, // Main paymode if needed
      paydate: new Date().toISOString().split("T")[0],
      grossamount: String(grossAmount),
      giftamount: String(voucherTotalAmount) || CON_VALUE_ZERO_ST,
      loyaltyamount: String(redeemAmountFromRedux) || "0",
      taxamount: String(table1Data.TAX) || CON_VALUE_ZERO_ST,
      cashamount: String(table1Data.CASHAPID) || CON_VALUE_ZERO_ST, //change this cash tenderd into totnett
      chequeamount: String(chequeTotalAmount || 0),
      slipamount: String(slipTotalAmount || 0),
      cardamount: String(cardTotalAmount || 0),
      discountrate: String(discountedTotal) || CON_VALUE_ZERO_ST,
      creditdueamount: CON_VALUE_ZERO_ST,
      adjustamount: String(adjustment),
      iscredit: "N",
      isPlaceOrder,
      ipaddress: clientIP,
    };

    try {
      const response = await externalpostApi(ORDER_API_07, payload);
      console.log("order confirm", response);
      const orderCode = response;
      setSnackbarMessage("Order placed successfully!");
      setSnackbarOpen(true);
      navigate("/OrderSuccess", {
        state: {
          source: "CashierPayment",
          snackbarMessage: MSG_CASHIER_SUCCESS,
          snackbarSeverity: "success",
          orderPayload: payload,
          orderCode: orderCode,
          table1Data,
        },
      });

      setSnackbarMessage(MSG_CASHIER_SUCCESS);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      // dispatch(clearCashierCart());

      // sessionStorage.clear();

      // setFormData();
      // Optionally clear Redux state or reset relevant components
      setFormData("");
      setCashTendered(0);
      setAdvanceAmount(0);
      setDiscountedTotal(0);
      setShippingCharge(0);
      setAdjustment(0);
      setDiscountValue(0);

      // Alternatively, remove specific keys
      sessionStorage.removeItem("cardList");
      sessionStorage.removeItem("chequeList");
      sessionStorage.removeItem("slipList");

      dispatch(setVoucherData([]));
      dispatch(clearCashierCart());
      dispatch(setRedeemAmount(""));
      dispatch(resetCards());
      dispatch(clearLoyaltyData());
    } catch (error) {
      console.error("Error placing order:", error);
      setSnackbarMessage("Failed to place order.");
      setSnackbarOpen(true);
    }
  };

  // API calls end
  return (
    <Grid spacing={0} sx={styles.aside_content} gap={0}>
      <Box sx={{ height: "100vh" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            aria-label="basic tabs example"
            sx={{
              ...styles.cp_main_tabs,

              "& .MuiTab-root.Mui-selected": {
                background: theme.palette.primary.main, // Selected tab background color (blue)
                color: "#fff", // Selected tab text color (white)
                boxShadow: 4,
              },
              // "& .MuiTab-root": {
              //   color: "#000",
              // },
            }}
          >
            <Tab label="Payment" {...a11yProps(0)} />
            <Tab label="Delivery" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CashierTabPanel value={value} index={0}>
          <Box sx={{ borderColor: "divider", paddingTop: 2 }}>
            <Tabs
              value={nestedValue}
              onChange={handleNestedChange}
              variant="fullWidth"
              aria-label="nested tabs example"
              sx={styles.tabs}
              indicatorColor={"none"}
            >
              <Tab
                icon={<LocalAtmIcon />}
                label="Cash"
                onClick={() => handleFormDataChange("cash", {})}
              />
              <Tab
                icon={<CreditCardIcon />}
                label="Card"
                onClick={() =>
                  handleFormDataChange("card", null, {
                    // name: "",
                    // accountNumber: "",
                    // amount: "",
                    // bank: "",
                    // branch: "",
                  })
                }
              />
              <Tab
                icon={<AccountBalanceIcon />}
                label="Deposit"
                onClick={() => handleFormDataChange("deposit", {})}
              />
              <Tab
                icon={<RedeemIcon />}
                label="Redeem"
                onClick={() => handleFormDataChange("redeem", {})}
              />
            </Tabs>
          </Box>
          <CashierTabPanel value={nestedValue} index={0}>
            <CashierCash
              onFormDataChange={(data) =>
                handleFormDataChange("cash", null, data)
              }
            />
          </CashierTabPanel>
          <CashierTabPanel value={nestedValue} index={1}>
            <CashierCard
              formData={formData}
              onFormDataChange={(data) =>
                handleFormDataChange("card", null, data)
              }
              setFormData={setFormData}
            />
          </CashierTabPanel>

          <CashierTabPanel value={nestedValue} index={2}>
            <Box sx={{ borderColor: "divider", paddingTop: 2 }}>
              <Tabs
                value={depositTabValue}
                onChange={handleDepositTabChange}
                variant="fullWidth"
                aria-label="deposit nested tabs"
              >
                <Tab label="Slip" {...a11yProps(0)} />
                <Tab label="Cheque" {...a11yProps(1)} />
              </Tabs>
            </Box>

            <CashierTabPanel value={depositTabValue} index={0}>
              <CashierSlip
                onFormDataChange={(data) =>
                  handleFormDataChange("deposit", "slip", data)
                }
                formData={formData}
                setFormData={setFormData}
              />
            </CashierTabPanel>
            <CashierTabPanel value={depositTabValue} index={1}>
              <CashierCheque
                onFormDataChange={(data) =>
                  handleFormDataChange("deposit", "cheque", data)
                }
                formData={formData}
                setFormData={setFormData}
              />
            </CashierTabPanel>
          </CashierTabPanel>

          <CashierTabPanel value={nestedValue} index={3}>
            <Box sx={{ borderColor: "divider", paddingTop: 2 }}>
              <Tabs
                value={redeemTabValue}
                onChange={handleRedeemTabChange}
                variant="fullWidth"
                aria-label="deposit nested tabs"
              >
                <Tab label="Loyalty Rewards" {...a11yProps(0)} />
                <Tab label="Gift Vouchers" {...a11yProps(1)} />
              </Tabs>
            </Box>

            <CashierTabPanel value={redeemTabValue} index={0}>
              <CashierLoyalty
                onFormDataChange={(data) =>
                  handleFormDataChange("redeem", "loyalty", data)
                }
              />
            </CashierTabPanel>
            <CashierTabPanel value={redeemTabValue} index={1}>
              <CashierVoucher
                onFormDataChange={(data) =>
                  handleFormDataChange("redeem", "voucher", data)
                }
                setVoucherData={setVoucherData}
              />
            </CashierTabPanel>
          </CashierTabPanel>
        </CashierTabPanel>
        <CashierTabPanel value={value} index={1}>
          <CashierDelivery />
        </CashierTabPanel>
      </Box>
      <Button
        sx={styles.btn_primary}
        onClick={handleConfirmOrder}
        size="medium"
        variant="contained"
      >
        Pay Now
      </Button>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity} // Dynamic severity (success or error)
      />
    </Grid>
  );
};
export default CashierPayment;
